import React from 'react';
import { FileSpreadsheet, FileText } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { downloadFeesExport } from './feesUtils';

const REPORTS = [
  { key: 'tracker', label: 'Class School Fees Tracker', desc: 'Spreadsheet of every student with installments, balances and status', needsSchool: true },
  { key: 'school_report', label: 'School Collection Report', desc: 'Class-by-class performance, school totals and the all-schools total' },
  { key: 'arrears', label: 'Arrears Report', desc: 'Balances brought forward, arrears collected and remaining per student' },
];

export const FeesReportsTab = ({ school, year, term }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="fees-reports">
    {REPORTS.map((r) => (
      <Card key={r.key}>
        <CardHeader className="pb-2">
          <CardTitle className="font-heading text-base">{r.label}</CardTitle>
          <CardDescription>{r.desc} · {year} Term {term}</CardDescription>
        </CardHeader>
        <CardContent className="flex gap-2">
          <Button variant="outline" size="sm" data-testid={`report-${r.key}-excel`}
            onClick={() => downloadFeesExport(r.key,
              { academic_year: year, term, format: 'excel', ...(r.needsSchool ? { school } : { school }) },
              `${r.key}_${year}_T${term}.xlsx`)}>
            <FileSpreadsheet className="h-3.5 w-3.5 mr-1" /> Excel
          </Button>
          <Button variant="outline" size="sm" data-testid={`report-${r.key}-pdf`}
            onClick={() => downloadFeesExport(r.key,
              { academic_year: year, term, format: 'pdf', ...(r.needsSchool ? { school } : { school }) },
              `${r.key}_${year}_T${term}.pdf`)}>
            <FileText className="h-3.5 w-3.5 mr-1" /> PDF
          </Button>
        </CardContent>
      </Card>
    ))}
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-base">Student Payment Statement</CardTitle>
        <CardDescription>Open any student from the Statements or Payment Tracker tab to download their individual statement (PDF/Excel)</CardDescription>
      </CardHeader>
    </Card>
  </div>
);
